import { taskTemplateSchema } from "@/components/Forms/schema/taskTemplateSchema.ts";
import useAuthenticatedFetch from "@/hooks/useAuthenticatedFetch.ts";
import { apiUrl } from "@/utils/api.ts";
import { type UseQueryResult, useQuery } from "@tanstack/react-query";
import { createResourceCollectionSelector } from "jsonapi-zod-query";

const taskTemplateTypeSelector = createResourceCollectionSelector({
    type: "taskTemplate",
    attributesSchema: taskTemplateSchema,
});

export type TaskTemplate = ReturnType<typeof taskTemplateTypeSelector>;

type Props = {
    searchString: string;
    isQueryEnabled?: boolean;
    subQueryKey?: string;
};
export const useFetchTaskTemplatesForAutocomplete = ({
    searchString,
    isQueryEnabled = true,
    subQueryKey = "task-template-autocomplete",
}: Props): UseQueryResult<TaskTemplate> => {
    const fetch = useAuthenticatedFetch();

    return useQuery({
        refetchOnWindowFocus: false,
        queryKey: [searchString, subQueryKey],
        enabled: isQueryEnabled,
        queryFn: async () => {
            const fetchURL = apiUrl("/task-template/search");

            const response = await fetch(fetchURL.href, {
                method: "POST",
                headers: {
                    "Content-Type": "application/vnd.api+json",
                },
                body: JSON.stringify({
                    searchString: searchString,
                }),
            });

            return await response.json();
        },
        select: taskTemplateTypeSelector,
    });
};
